import React, {Component} from 'react';

export default class TableNoData extends Component {
    render() {
        const {columnWidths, columnHeaderTitles, minWidth, textComponent} = this.props;

        return (
            columnWidths && (columnWidths.length > 0) ?
                <div id={this.props.tableId} className={'table-nodata'}>
                    <div className='table-header-nodata' style={{minWidth}}>
                        {columnHeaderTitles.map((title, index) => <p key={index}
                                                                     style={{width: columnWidths[index]}}>{title}</p>)}
                    </div>
                    {textComponent}
                </div>
                :
                <div/>
        )
    }
}